import React from 'react';
import { Sparkles } from 'lucide-react';

export default function SchemaStep({ schema, validation }) {
  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <div>
          <h3 className="text-sm font-bold text-slate-900">Generated JSON Schema preview</h3>
          <p className="text-xs text-slate-500">{validation.objects.length} records · ready to publish into the {schema.label}</p>
        </div>
      </div>
      <div className="rounded-xl border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto max-h-[280px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 sticky top-0">
              <tr>
                {schema.fields.slice(0, 6).map((f) => (
                  <th key={f.key} className="px-3 py-2.5 text-left text-[10px] font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">
                    {f.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {validation.objects.slice(0, 30).map((row, i) => (
                <tr key={`val-row-${i}-${row[schema.fields[0].key] || ''}`} className="border-t border-slate-100 hover:bg-slate-50/40">
                  {schema.fields.slice(0, 6).map((f) => (
                    <td key={f.key} className="px-3 py-2 text-xs text-slate-700 whitespace-nowrap max-w-[260px] truncate" title={row[f.key]}>
                      {row[f.key] || <span className="text-slate-300">—</span>}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-4 p-3 rounded-lg bg-blue-50 border border-blue-200 flex items-start gap-2">
        <Sparkles className="w-4 h-4 text-blue-700 flex-shrink-0 mt-0.5" />
        <div className="text-xs text-blue-900">
          Schema generated for <span className="font-bold">{schema.label}</span>. Continue to publish, or save as Draft to review later.
        </div>
      </div>
    </div>
  );
}
